import React, { memo } from "react";
import {
  Box,
  Container,
  Grid2,
  Stack,
  Typography,
} from "@mui/material";
import { MailOutlineRounded } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FullPaddingWrapper } from "../FullPaddingWrapper/FullPaddingWrapper";
import NewsletterSignup from "../NewsletterSignup/NewsletterSignup";
import APP_ROUTES from "../../Configurations/APP_ROUTES";
import { RootState } from "../../Store/store";
import { setToggleAuthModal } from "../../Redux/authReducer";

const Footer = memo(() => {
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector(
    (state: RootState) => state?.auth || {}
  );

  const isLoggedIn =
    isAuthenticated &&
    user &&
    Object.keys(user || {}).length > 0;

  const handleMyAccountClick = () => {
    if (!isLoggedIn) {
      dispatch(setToggleAuthModal(true));
    }
  };

  return (
    <Box bgcolor={"white"} pt={{ xs: "20px", md: "50px" }} position={"relative"} mt={{ xs: "20px", md: "50px" }}>
      <Box sx={{ backgroundColor: "backgroundLight2.main" }} mt={{ xs: 2, md: 5 }}>
        <Container maxWidth="xl">
          <FullPaddingWrapper>
            <Box py={{ xs: 5, md: 10 }} sx={{ backgroundColor: "backgroundLight2.main" }}>
              <Box>
                <Grid2 container spacing={{ xs: 5, md: 10 }}>
                  <Grid2
                    size={{ xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }}
                    sx={{ order: { xs: 2, sm: 1 } }}
                  >
                    <Box>
                      <Grid2 container spacing={5}>
                        <Grid2 size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                          <Stack spacing={"20px"}>
                            <Typography variant="h6" fontWeight={"700"}>
                              Homeowner Resources
                            </Typography>
                            <Stack direction={"column"} spacing={0.5}>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                component={isLoggedIn ? Link : "a"}
                                {...(isLoggedIn
                                  ? { to: String(APP_ROUTES.MY_ACCOUNT.pathname) }
                                  : { href: "#", onClick: handleMyAccountClick })}
                                sx={{ textDecoration: "none", cursor: "pointer" }}
                                color="textPrimary"
                              >
                                My Account
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                component={Link}
                                to={String(APP_ROUTES.TRUE_COST_GUIDE.pathname)}
                                sx={{ textDecoration: "none" }}
                                color="textPrimary"
                              >
                                True Cost Guide
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                component={Link}
                                to={String(APP_ROUTES.HOME_MAINTENANCE_GUIDE.pathname)}
                                sx={{ textDecoration: "none" }}
                                color="textPrimary"
                              >
                                Home Maintenance Guide
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                component={Link}
                                to={String(APP_ROUTES.MESSAGE_FROM_TEAM.pathname)}
                                sx={{ textDecoration: "none" }}
                                color="textPrimary"
                              >
                                A Note from Our Team
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                component={Link}
                                to={String(APP_ROUTES.LICENSING_REQUIREMENTS.pathname)}
                                sx={{ textDecoration: "none" }}
                                color="textPrimary"
                              >
                                Licensing Requirements
                              </Typography>
                            </Stack>
                          </Stack>
                        </Grid2>
                        <Grid2 size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                          <Stack spacing={"20px"}>
                            <Typography variant="h6" fontWeight={"700"}>
                              About Simplerhome
                            </Typography>
                            <Stack direction={"column"} spacing={0.5}>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                color="textPrimary"
                                component={Link}
                                to={String(APP_ROUTES.PROPERTY_PROFESSIONAL.pathname)}
                                sx={{ textDecoration: "none" }}
                              >
                                Work with Us
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                color="textPrimary"
                                component={Link}
                                to={String(APP_ROUTES.CAREERS.pathname)}
                                sx={{ textDecoration: "none" }}
                              >
                                Careers
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                color="textPrimary"
                                component={Link}
                                to={String(APP_ROUTES.PRESS.pathname)}
                                sx={{ textDecoration: "none" }}
                              >
                                Press
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                color="textPrimary"
                                component={Link}
                                to={String(APP_ROUTES.BLOG.pathname)}
                                sx={{ textDecoration: "none" }}
                              >
                                Blog
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                color="textPrimary"
                                component={Link}
                                to={String(APP_ROUTES.TERMS_PRIVACY.pathname)}
                                sx={{ textDecoration: "none" }}
                              >
                                Terms & Privacy
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                color="textPrimary"
                                component={Link}
                                to={String(APP_ROUTES.DO_NOT_SELL.pathname)}
                                sx={{ textDecoration: "none" }}
                              >
                                Do Not Sell My Personal Information
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                color="textPrimary"
                                component={Link}
                                to={String(APP_ROUTES.LEGAL.pathname)}
                                sx={{ textDecoration: "none" }}
                              >
                                Legal
                              </Typography>
                              <Typography
                                variant="subtitle1"
                                fontWeight={"400"}
                                color="textPrimary"
                                component={Link}
                                to={String(APP_ROUTES.CONTACT.pathname)}
                                sx={{ textDecoration: "none" }}
                              >
                                Contact
                              </Typography>
                            </Stack>
                          </Stack>
                        </Grid2>
                      </Grid2>
                    </Box>
                  </Grid2>
                  <Grid2
                    size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }}
                    sx={{ order: { xs: 1, sm: 2 } }}
                  >
                    <Box
                      id="newsletter-signup"
                      position={{
                        lg: "absolute",
                        xl: "absolute",
                        md: "relative",
                        sm: "relative",
                        xs: "relative",
                      }}
                      top={0}
                    >
                      <NewsletterSignup />
                      {/* The LinkedIn/X icons that sat here linked nowhere;
                          until there are real profiles, an address that works. */}
                      <Box mt={{ xs: 5, lg: 10 }}>
                        <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent={{ xs: "flex-start", lg: "flex-end" }}>
                          <MailOutlineRounded color="primary" fontSize="small" />
                          <Typography
                            variant="subtitle1"
                            component="a"
                            href="mailto:info@simplerhome.app"
                            color="primary"
                            sx={{ textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
                          >
                            info@simplerhome.app
                          </Typography>
                        </Stack>
                      </Box>
                    </Box>
                  </Grid2>
                </Grid2>
              </Box>
              <Box mt={5}>
                <Typography variant="caption" sx={{ opacity: "0.5" }}>
                  © {new Date().getFullYear()} SimplerHome | All Rights Reserved
                </Typography>
              </Box>
            </Box>
          </FullPaddingWrapper>
        </Container>
      </Box>
    </Box>
  );
});

export default Footer;
